

var _squid = require('squid');

var _util = require('../../lib/util');

var _contentKeys = require('../../lib/contentKeys');

define(['jquery', 'angular', 'squid/index', 'text!./template.html', '../lib/util', 'components/xo-page-components/src/value-props/directive', 'components/xo-models/src/onboard/index', 'components/xo-models/src/fi/index', 'components/xo-form-components/src/dob-input/directive', 'components/xo-form-components/src/national-id-input/directive', 'components/xo-models/src/user/index', '../apiCalls/factory'], function ($, angular, module, template, util) {

    return angular.module('xo-multistep-signup-create-account.directive', ['squid', 'xomodel.onboard', 'xo-value-props.directive', 'xo-dob-input.directive', 'xo-national-id-input.directive', 'xomodel.user', 'xomultistepsignupapi']).directive('xoMultistepSignupCreateAccount', function () {

        return {
            template: template,

            scope: {
                token: '=',
                parentCallbacks: '=',
                multistepSignupModel: '=',
                positionToErrorField: '=',
                backState: '=',
                backendError: '=',
                clearBackendError: '='
            },

            controller: function controller($scope, $rootScope, $populate, $state, $util, $locale, $ShippingAddressModel, $logger, $CheckoutSessionModel, $CheckoutAppDataModel, $CheckoutCartModel, $UserInfoModel, $dispatch, $pxpFactors, $config, $MultistepApiCalls, $pxp) {

                $scope.locale = $locale;
                $scope.componentsFlag = util.componentsMap($locale.country);
                $scope.metadata = angular.copy($locale.metadata);
                $scope.countries = $scope.metadata.territory;

                $scope.checkoutCart = $CheckoutCartModel.instance($scope.token);
                $scope.checkoutAppData = $CheckoutAppDataModel.instance($scope.token);

                if ($scope.checkoutAppData && $scope.checkoutAppData.merchant) {
                    var merchant = $scope.checkoutAppData.merchant;
                    $scope.merchant = merchant.brand_name || merchant.merchant_name || merchant.merchant_email;
                }

                function formatFiLast4(ccNum) {
                    return 'x-' + ccNum.replace(/\s+/g, '').slice(-4);
                }

                function formatFiName(ccType) {
                    var tmp = ccType.toLowerCase();
                    return tmp.charAt(0).toUpperCase() + tmp.slice(1);
                }

                var contentOpts = {
                    cart: $scope.checkoutCart,
                    appData: $scope.checkoutAppData
                };

                $scope.baContentKey = (0, _contentKeys.getBAContentKey)(contentOpts);
                $scope.rpContentKey = (0, _contentKeys.getRPContentKey)(contentOpts);

                $scope.fiName = formatFiName($scope.multistepSignupModel.onboard.card.type);
                $scope.fiFormatLast4 = formatFiLast4($scope.multistepSignupModel.onboard.card.number);

                // Reset password fields
                delete $scope.multistepSignupModel.onboard.user.password;
                delete $scope.multistepSignupModel.onboard.user.confirmPassword;

                var useraction = $scope.checkoutAppData.useraction();
                $scope.isCommit = useraction && useraction.toLowerCase() === 'commit';
                $logger.info('checkout_fpti', {
                    'billing_page_button_text': $scope.isCommit ? 'paynow_y' : 'paynow_n'
                });

                if (!$rootScope.miniBrowser && $locale.country === 'BR') {
                    var brPxp = $config.pxpExperiments.BR.xo_br_hermesnode_createaccount_design;

                    $pxpFactors(brPxp.pgName, brPxp.params, brPxp.pattern).then(function (result) {
                        $scope.createAccountDesignExp = result;
                    });
                }

                function handleUIValidation(fields) {
                    var $fields = $(fields);

                    $fields.addClass('backendError');

                    if (window.scrollTo) {
                        window.scrollTo(0, 0);
                    }
                }

                function isNameCyrillic() {
                    var result = true;
                    var regexCyrillic = /[а-яА-ЯЁё]/;
                    if (!regexCyrillic.test($('#firstName').val())) {
                        result = false;
                        handleUIValidation('#firstName');
                    }
                    if (!regexCyrillic.test($('#lastName').val())) {
                        result = false;
                        handleUIValidation('#lastName');
                    }
                    if (!regexCyrillic.test($('#middleName').val())) {
                        result = false;
                        handleUIValidation('#middleName');
                    }

                    if (!result) {
                        var messages = [];
                        messages.push($locale.content.get('addTaxId.cyrillicNameError'));
                        $scope.multistepSignupModel.pageError = $scope.multistepSignupModel.pageError || {};
                        $scope.multistepSignupModel.pageError.multistepsignupcreateaccount = {
                            errorMessage: {
                                msgs: messages,
                                type: 'error'
                            }
                        };
                    }

                    return result;
                }

                _util.pxpTreatments.getSinglePassword($locale.country).then(function (res) {
                    $scope.singlePassword = res;
                });

                $scope.onContinue = function () {
                    var validInput = true;
                    if ($scope.multistepSignupModel.onboard.user.countryOfResidence === 'RU') {
                        validInput = isNameCyrillic();
                    }

                    if (!util.validateLegalAge($scope.multistepSignupModel.onboard.user.dob_month, $scope.multistepSignupModel.onboard.user.dob_day, $scope.multistepSignupModel.onboard.user.dob_year)) {
                        validInput = false;
                        handleUIValidation('#dobText');
                    }

                    if (validInput) {
                        $scope.onSubmit();
                    }
                };

                $scope.legalAgreeToolTip = function () {
                    if ($scope.multistepSignupModel.onboard.agree) {
                        $scope.showTooltip = false;
                    } else {
                        $scope.showTooltip = true;
                    }
                };

                $scope.validate = function () {
                    $scope.legalAgreeToolTip();
                    $scope.validated = true;
                    return true;
                };

                $scope.onComplete3DSHandler = function (status) {
                    $scope.multistepSignupModel.is3ds = false;
                    if (status === 'decline' || status === 'close') {
                        // Flow should route to member review page for sign up case
                        // up on receiving "decline" or "close" response from 3DS authenticate call
                        $MultistepApiCalls.routeToHermesOn3DSDeclineForSignUp();
                    } else if (status === 'success') {
                        // Up on Successful authenticate, perform Patch on XO session and authorise.
                        $MultistepApiCalls.clear3DSContingency();
                    }
                };

                $scope.onSubmit = function () {

                    var countryThrottle = $config.features[$locale.country] && $config.features[$locale.country].oasThrottleSignup;
                    var throttle = countryThrottle ? countryThrottle : $config.features.DEFAULT.oasThrottleSignup;
                    var isOASFlow = throttle ? (0, _squid.$experiment)('oas', throttle, $scope.token, {}) : false;

                    if ($util.param('oas') === 'true') {
                        isOASFlow = true;
                    } else if ($util.param('oas') === 'false') {
                        isOASFlow = false;
                    }

                    $logger.info($scope.multistepSignupModel.flags.mode + '_submit', {
                        type: $scope.multistepSignupModel.onboard.card.type,
                        country: $locale.country,
                        lang: $locale.lang
                    }).flush();

                    if ($scope.multistepSignupModel.flags.shipToBilling) {
                        $scope.multistepSignupModel.onboard.shipping_address = $ShippingAddressModel.create($scope.token, $scope.multistepSignupModel.onboard.billing_address, {
                            first_name: $scope.multistepSignupModel.onboard.user.first_name,
                            last_name: $scope.multistepSignupModel.onboard.user.last_name
                        });
                    }

                    $MultistepApiCalls.onboard(isOASFlow)['catch'](function (pageError) {
                        var addCard = pageError.multistepsignupaddcard;
                        var addShipping = pageError.multistepsignupaddshipping;
                        var createAcc = pageError.multistepsignupcreateaccount;

                        // Globally handled contingencies also trigger the catch block.
                        if (addCard && addCard.length > 0) {
                            $state.go('checkout.multistepsignup.multistepsignupaddcard');
                        } else if (addShipping && addShipping.length > 0) {
                            $state.go('checkout.multistepsignup.multistepsignupaddshipping');
                        } else if (createAcc && createAcc.length > 0) {
                            $scope.backendError('multistepsignupcreateaccount');
                        }
                    });
                };
            }
        };
    });
});

_squid.$experiment;

_util.pxpTreatments;

_contentKeys.getBAContentKey;

_contentKeys.getRPContentKey;


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/multistep-signup/createAccount/directive.js
// module id = ./components/xo-guest-components/src/multistep-signup/createAccount/directive.js
// module chunks = 1